globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.TasksProjects = appCustomerSpace.Modals.TasksProjects || {};

appCustomerSpace.Modals.TasksProjects.Task = (function(superClass) {

  utils.extend(Task, superClass);

  function Task() {
    Task.__super__.constructor.apply(this, arguments);
  }

  $.extend(Task.prototype, {
    init: function() {
      var modal = this;

      modal.$html.on('click', '.btn-status', function(){
        modal.$html.find('form .input-status').val($(this).data('status')).trigger('change');
      });

      modal.$html.on('change', 'form input', function(){
        var $form = $(this).closest('form');
        $('body').addClass('loading');

        $.ajax({
          url: $form.attr('action'),
          method: $form.attr('method'),
          data: $form.serialize(),
          success: function(data) {
            if(data.response) {
              var $taskProjectThumb = $('#tasks-project-' + modal.projectId()),
                  $taskThumbLine = $taskProjectThumb.find('.task[data-id='+modal.taskId()+']')
                  $updatedTaskThumbLine = $(data.html.thumb_line),
                  $taskModalContent = modal.$html.find('.modal-content'),
                  $updatedTaskModalContent = $(data.html.modal_content),
                  progress = data.data.progress_percentage;

              $taskProjectThumb.find('.progress-bar').css('width', progress + '%')
              $taskProjectThumb.find('.progress-integer').html(progress);

              $updatedTaskThumbLine.find('[data-popup="tooltip"]').tooltip();

              $taskThumbLine.replaceWith($updatedTaskThumbLine);
              $taskModalContent.replaceWith($updatedTaskModalContent);
              $('body').removeClass('loading');
            }
          },
          error: function(data) {}
        })
      });

      return Task.__super__.init.apply(this, arguments);
    },
    taskId: function(){
      return this.$html.data('id')
    },
    projectId: function(){
      return this.$html.data('project-id');
    }
  });

  return Task;

})(appCustomerSpace.Modal);
